<template lang="pug">
  v-container(grid-list-md)
    v-layout(row, wrap)
      v-flex(xs12)
        v-toolbar(dense, dark, color="cyan")
          v-icon(style="font-size: 28px") timeline
          v-toolbar-title.subheading Approval Timeline
          v-spacer
        
        v-timeline(
          v-if="item.ipForm === 'BIB-HSE-PPO-F-012-01'",
          align-top,
          dense
        )
          TimelineItems(
            :item="item"
            :config="config"
            :getWITADate="getWITADate"
            :timelineDetail="timelineDetail"
            :getNameApproverKTT="getNameApproverKTT"
            :getTitleApprover="getTitleApprover"
            :formType="'BIB-HSE-PPO-F-012-01'"
          )

        v-timeline(
          v-else-if="item.ipWorkflow.length === 6 && item.ipForm !== 'BIB-HSE-PPO-FRM-018-03' && item.ipForm !== 'BIB-HSE-ES-F-2.07-01'",
          align-top,
          dense
        )
          TimelineItems(
            :item="item"
            :config="config"
            :getWITADate="getWITADate"
            :timelineDetail="timelineDetail"
            :getNameApproverKTT="getNameApproverKTT"
            :getTitleApprover="getTitleApprover"
            :formType="'6 Workflows Form'"
          )

        v-timeline(
          v-else-if="item.ipWorkflow.length === 4 && item.ipForm !== config.FormCode.izinJangkaPendek",
          align-top,
          dense
        )
          TimelineItems(
            :item="item"
            :config="config"
            :getWITADate="getWITADate"
            :timelineDetail="timelineDetail"
            :getNameApproverKTT="getNameApproverKTT"
            :getTitleApprover="getTitleApprover"
            :formType="'4 Workflows Form'"
          )

        v-timeline(
          v-if="item.ipForm === 'BIB-HSE-PPO-IZIN-TAMU'",
          align-top,
          dense
        )
          TimelineItems(
            :item="item"
            :config="config"
            :getWITADate="getWITADate"
            :timelineDetail="timelineDetail"
            :getNameApproverKTT="getNameApproverKTT"
            :getTitleApprover="getTitleApprover"
            :formType="'BIB-HSE-PPO-IZIN-TAMU'"
          )

        v-timeline(
          v-if="item.ipForm == 'BIB-HSE-PPO-FRM-018-03'",
          align-top,
          dense
        )
          TimelineItems(
            :item="item"
            :config="config"
            :getWITADate="getWITADate"
            :timelineDetail="timelineDetail"
            :getNameApproverKTT="getNameApproverKTT"
            :getTitleApprover="getTitleApprover"
          )

        v-timeline(
          v-if="item.ipForm == 'BIB-HSE-PPO-F-071-01'",
          align-top,
          dense
        )
          TimelineItems(
            :item="item"
            :config="config"
            :getWITADate="getWITADate"
            :timelineDetail="timelineDetail"
            :getNameApproverKTT="getNameApproverKTT"
            :getTitleApprover="getTitleApprover"
          )

        v-timeline(
          v-if="item.ipForm == 'BIB-HSE-PPO-F-071-02'",
          align-top,
          dense
        )
          TimelineItems(
            :item="item"
            :config="config"
            :getWITADate="getWITADate"
            :timelineDetail="timelineDetail"
            :getNameApproverKTT="getNameApproverKTT"
            :getTitleApprover="getTitleApprover"
          )

        v-timeline(
          v-if="item.ipForm == 'BIB-HSE-ES-F-2.07-01'",
          align-top,
          dense
        )
          TimelineItems(
            :item="item"
            :config="config"
            :getWITADate="getWITADate"
            :timelineDetail="timelineDetail"
            :getNameApproverKTT="getNameApproverKTT"
            :getTitleApprover="getTitleApprover"
          )
</template>

<script>
import TimelineItems from './TimelineItems.vue'; // Import the reusable TimelineItems component

export default {
  name: "TimelinePermitList",
  components: {
    TimelineItems, // Register the reusable component
  },
  props: {
    item: Object,
    config: Object,
    getWITADate: Function,
    timelineDetail: Function,
    getNameApproverKTT: Function,
    getTitleApprover: Function,
  },
};
</script>
